import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { TextFieldPropsWithEdit } from '@/types';

interface ManifestCheckNameFieldProps extends TextFieldPropsWithEdit {}

export default function ManifestCheckNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}: ManifestCheckNameFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Check name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Check name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Name'
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          required
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
          InputLabelProps={{ shrink: value?.length > 0 }}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a friendly name for the manifest check
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

